var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreatmentApproachMixed1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 211.4 137.9",
    style: {
      enableBackground: "new 0 0 211.4 137.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#36393A;stroke-width:1.195;stroke-miterlimit:10;}\n\t.st1{fill:#FDE3DF;stroke:#FF2C46;stroke-width:1.03;stroke-miterlimit:10;}\n\t.st2{fill:none;}\n\t.st3{fill:#FFFFFF;stroke:#CDD4D7;stroke-miterlimit:10;}\n\t.st4{fill:#FFFFFF;stroke:#CDD4D7;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4321",
    className: "st0",
    d: "M206.4,114.9l1.4-16.2c0.4-6.3-4.1-11.8-10.3-12.5c-25.5-3-90.5,17.8-197.3-10.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4324",
    className: "st0",
    d: "M198.9,15.2l4.5,22.2c1.1,6.2-2.8,12.2-8.9,13.6C169.4,56.8,105,67.8,9,57.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4325",
    className: "st1",
    d: "M194.4,84.3c0,0,1.7,5,3.1,5.2s4.8-13.8,5.2-15.9c0.3-2,0.3-4,0-6l-11.1,3.2L194.4,84.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4327",
    className: "st1",
    d: "M189.1,84.3c0,0,2.4,7.4,3.6,7.6s3-6.9,3.5-9.1c0.4-2.1,3.6-13.5,3.5-15.6 c-0.2-2.1-11.4,5.2-11.4,5.2L189.1,84.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4329",
    className: "st1",
    d: "M179.4,81.4c0,0,0.3,12.6,6.6,12.5c1.8-0.2,2.8,0,8.7-24.5L182.5,68L179.4,81.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4331",
    className: "st1",
    d: "M162.5,77c0,0,5.3,13.5,7,15.5c1.3,1.6,2.9,2.4,3.9,2.3s4.3-3,5.6-8s3.5-18.1,3.5-18.1L162,69.4 L162.5,77z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4342",
    className: "st1",
    d: "M66.2,73.3c-0.5,3.1-0.7,6.1-0.8,9.2c0.1,1.9,1.9,5.8,4,8.2c3,3.4,12.2,5.4,18.7,4.3 c6.5-1.1,12.1-14.2,12.1-14.8s-2.7-6.6-3.4-6.9c-2.2-0.7-4.4-1.4-6.7-1.9C89.8,71.5,66.2,73.3,66.2,73.3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4322",
    className: "st1",
    d: "M191.6,41.1c0,0,0-9.4,1.8-10.7s18.1,16.8,17.3,33.4c0,0,0,3.6-4.4,3.9c-2.2,0-4.3,0.4-6.4,1 L191.6,41.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4344",
    className: "st1",
    d: "M62.4,65.3c0,0,1.3-12.1,11.3-12.1s13.4,2.6,16.6,5.5s4.5,12.9,4.2,13.4 c-0.4,0.6-5.1,6.6-11,6.8c-3,0.1-7-4.8-8.9-4.9c-3.5-0.1-2.2,4.5-7,4.1C64.3,77.9,61.5,72.7,62.4,65.3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4333",
    className: "st1",
    d: "M177.5,55.2c0,0,0.3-10.8,0.8-13.7c0.6-4,2.9-9.2,5.6-9.4s9.9,5.7,19.5,30.4c0,0,2.6,6-1.7,6.9 c-3.3,0.7-9.4,1.4-12.2,1.7c-1.2,0.1-2.3,0-3.4-0.3c-1.9-0.5-4.4-1.6-5.3-4C179.4,63,177.5,55.2,177.5,55.2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4335",
    className: "st1",
    d: "M160.2,45.1c0,0,3.2-12.4,8.6-11.6c2.9,0.6,4.9,5.6,6.6,10.8s8.7,21.2,8.1,24.2 s-5.2,3.2-5.2,3.2l-7.6,0.6c-1.3,0.1-2.6-0.1-3.8-0.5c-1.7-0.6-3.9-1.7-4.9-3.4c-1.5-2.7-2.7-5.4-3.6-8.3 C158.2,55.1,158.8,50,160.2,45.1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1723",
    y: 8,
    className: "st2",
    width: 211.3,
    height: 106.9
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4360",
    className: "st3",
    d: "M94.9,111.6c-0.1,3.3,0.4,6.7,1.5,9.8c1.5,4.6,2.6,8.5,7.1,8.4c4.5-0.1,5.8-1.8,7.2-5 c1.2-3.1,2.2-6.2,3-9.4c0.4-2,0.2-4-0.8-5.8c-0.5-1.1-5.9-6-9.2-5.9C99.7,103.9,94.9,108.9,94.9,111.6L94.9,111.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4362",
    className: "st3",
    d: "M139.4,114.3c0,0,2.7,10.6,3.9,13.8c0.7,2.4,2.3,4.5,4.5,5.8c2.2,1.5,6.6,3.8,9.1,3.2 s3.6-3.5,4-4.9c0.5-1.8,3.8-20.6,3-23.3c-0.9-2.7-3.1-4.7-5.8-5.5c-3.2-0.5-9.6,1.7-12.3,3.4C143.7,108,139.4,114.3,139.4,114.3 L139.4,114.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4361",
    className: "st4",
    d: "M115.8,112.5c0,0,2.5,10.7,3.8,14.6s3.3,9.2,7.6,10s7.7-0.6,8.4-3.8s5.7-17.4,5.5-19.4 s-3.5-5.5-5.4-6.9s-6.1-4-9.8-3.9S115.8,112.5,115.8,112.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4358",
    className: "st3",
    d: "M32.1,44.2c0,0,1.3-12.2,11.4-12.2s13.5,2.7,16.7,5.5s4.6,12.9,4.2,13.5 c-0.4,0.6-5.1,6.7-11,6.8c-3,0.1-7-4.8-8.9-4.9c-3.5-0.1-2.2,4.5-7,4.1C34,56.8,31.2,51.6,32.1,44.2L32.1,44.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4357",
    className: "st3",
    d: "M86.3,29.3c0,0-2.9,13-1,15.5s4.7,5,8.1,4.7s8.3-3,9.4-3.9c1.3-1.1,3.8-3.8,4-6.6 s-1.8-6.4-2.7-8.5s-3.3-11.7-10.3-12C87.6,18.3,86.3,29.3,86.3,29.3L86.3,29.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4355",
    className: "st3",
    d: "M130.6,11.6c0,0.6,0.6,6.9,0.3,9.5c-0.2,1.6-2.9,6.9-0.1,10.4s7.2,10.7,16.2,9.5 s11.3-8.5,11.5-11.1c0.1-2.6-2-12.3-3.8-16.6c-1.8-4.4-8.1-13.8-16-12.8S130.6,11.5,130.6,11.6L130.6,11.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4359",
    className: "st3",
    d: "M28.3,98c0,0-0.3,12.2,9.6,13.6s13.7-0.8,17.3-3.2s6.3-12.2,6-12.8s-4.2-7.3-10-8.3 c-3-0.5-7.6,3.8-9.5,3.6c-3.5-0.3-1.6-4.7-6.4-5.1C31.9,85.7,28.4,90.5,28.3,98L28.3,98z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4356",
    className: "st3",
    d: "M107.7,21.1c0,0-3.1,13.8,0.3,16s9.7,5.7,11.9,5.3s8.3-7.8,9.9-8.9c1.1-0.6,1.7-1.8,1.6-3 c0-0.9-4-7.8-5.1-12S122,7,115.3,7.5S107.7,21.1,107.7,21.1L107.7,21.1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4341",
    className: "st1",
    d: "M106.6,95.8c4.1,1.4,8.5,1.2,12.4-0.6c4.6-2.4,6.5-8.7,5.4-13.4s-4.7-7-5.6-7 c-3.3,0.3-4.1,3.6-5.9,3.6c-3.5,0-4.3-2.7-8.1-2.7c-2.1,0-5.3,3.1-5.7,6.8C98.5,87.8,103.2,94.5,106.6,95.8L106.6,95.8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4339",
    className: "st1",
    d: "M129.2,94.5c3.5,1.2,7.4,1,10.7-0.5c3.9-2.1,5.6-7.5,4.7-11.5s-2.3-6.1-4.9-6 c-2.9,0.1-4.2,2.5-5.8,2.5c-3,0-3.1-1.7-6.4-1.7c-1.8,0-4.5,2.7-4.9,5.9C122.2,87.7,126.3,93.4,129.2,94.5L129.2,94.5z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4337",
    className: "st1",
    d: "M144.3,80.4c-0.5,2.8,3.6,18.1,9.9,18.1c2.1,0,5.1-3.4,5.7-6.4c0.3-1.4,2.7-14.2,2.1-16.4 c-0.7-2.1-2.5-3.8-4.6-4.4c-2.5-0.4-7.7,1.4-9.8,2.7C145.8,75.2,144.6,78.5,144.3,80.4L144.3,80.4z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4338",
    className: "st1",
    d: "M141.2,63.1c-0.2,1.1-1.3,5.2,0.5,7.7s5.3,5.8,9.3,5.8c3.6,0,7.8-5.8,7.9-7.6 c0.1-1.8-1.4-8.4-2.6-11.3c-1.2-3-3.9-7.4-9.3-6.7S141.5,61.3,141.2,63.1L141.2,63.1z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4346",
    className: "st1",
    d: "M117.6,69.4c0,0-2.8-7.8-5.4-9c-3.2-1.4-6.8-1.3-9.9,0.3c-3.8,2.1-6.6,9.1-6.1,13.4 c0.2,2.7,2.2,4.9,4.9,5.4c2.6-0.2,3.5-3.2,4.9-3.2c2.7,0.1,3.3,2.6,6.2,2.7c1.7,0,7-4.1,6.6-5.5C118.6,72,117.6,69.4,117.6,69.4 L117.6,69.4z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4340",
    className: "st1",
    d: "M140,70c0,0-3-8-5.7-9.2c-3.3-1.4-7-1.3-10.1,0.4c-3.8,2.2-6.7,9.4-6.1,13.8 c0.3,2.8,2.4,5,5.1,5.4c2.7-0.2,3.6-3.4,5-3.3c2.8,0.1,3.4,2.7,6.5,2.7c1.7,0,7.1-4.3,6.7-5.7C141,72.6,140,70,140,70L140,70z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreatmentApproachMixed1);
export default __webpack_public_path__ + "static/media/treatment_approach_mixed_1.00549e1cef4117e0d81c91f3f2a6b6ab.svg";
export { ForwardRef as ReactComponent };